import {useReducer} from "react";
import {getProducts} from "../api/product-search";
import {debounce} from "lodash";

const actions = {
    RESET: "reset",
    LOADING: "loading",
    SET_PRODUCTS: "set-products"
}

const initialState = {
    loading: false,
    loaded: false,
    total: 0,
    items: []
};

function reducer(state, action) {
    switch (action.type) {
        case actions.RESET:
            return {...initialState};

        case actions.LOADING:
            return {...initialState, loading: true}

        case actions.SET_PRODUCTS:
            return {
                loading: false,
                loaded: true,
                total: action.products.total,
                items: action.products.items,
            }
    }
}

function useSuggestions(size = 10, language) {
    const [state, dispatch] = useReducer(reducer, initialState);

    const loadSuggestions = debounce((query) => {
        dispatch({type: actions.RESET});
        const fetchProducts = async () => {
            try {
                dispatch({type: actions.LOADING});
                const products = await getProducts(window.SiteConfig.baseUrl.concat('/ajax/products-search'), query, size, language);
                dispatch({type: actions.SET_PRODUCTS, products: products})
            } catch (e) {
                // Handle CancelledException
            }
        }

        fetchProducts();
    }, 500);

    return {
        suggestions: {
            total: state.total,
            items: state.items,
        },
        loading: state.loading,
        loaded: state.loaded,
        loadSuggestions
    };
}

export default useSuggestions;